/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Card,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import examType1Services from '../../redux/services/examType1Services';
import GradeCard from './GradeCard';

const useStyles = makeStyles((theme) => ({
  answer: {
    marginBottom: '15px',
  },
  modal: {
    width: '900px',
  },
  totalCard: {
    // minHeight: '100px',
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
}));

const ExamResultsDetails = ({
  examId, setExamId, open, setOpen,
}) => {
  const [data, setData] = useState();
  const [examResults, setExamResults] = useState();
  const [totals, setTotals] = useState({});
  const classes = useStyles();

  const columns = [
    {
      title: 'Question',
      field: 'question',
    },
    {
      title: 'Type',
      field: 'type',
    },
    {
      title: 'Category',
      field: 'category',
    },
    {
      title: 'Answers',
      field: 'answer',
      render: ({ answers }) => (
        <td>
          {answers.map((answer) => (answer.isRight && answer.isChosen
            ? <div className={classes.answer} style={{ color: 'green' }}>{answer.text}</div>
            : (answer.isChosen
              ? <div className={classes.answer} style={{ color: 'red' }}>{answer.text}</div>
              : <div className={classes.answer} style={{ color: 'black' }}>{answer.text}</div>)
          ))}
        </td>
      ),
    },
    {
      title: 'Points',
      field: 'points',
    },
  ];

  useEffect(async () => {
    const dataArr = [];
    const res = await examType1Services.getTestById(examId);
    setData(res.examScores);
    let KNTotal = 0;
    let RCTotal = 0;
    res.answers.forEach((answer) => {
      let points = 0;
      const answersArr = [];
      answer.question.answers.forEach((item, index) => {
        const answerItem = { ...item, isChosen: false };
        answer.answerIndex.forEach((elem) => {
          if (elem === index) {
            answerItem.isChosen = true;
          }
        });
        answersArr.push(answerItem);
      });
      if (answer.valid) {
        points = answer.question.coefficient;
      }

      if (answer.category === 'KN') {
        KNTotal += answer.coefficient;
      } else {
        RCTotal += answer.coefficient;
      }

      dataArr.push({
        question: answer.question.name,
        type: answer.question.type,
        category: answer.question.category,
        answers: answersArr,
        valid: answer.valid,
        points: `${points}/${answer.question.coefficient}`,
      });
    });
    setExamResults(dataArr);
    setTotals({
      KNTotal,
      RCTotal,
    });
  }, [examId]);

  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth="900px"
        maxWidth="900px"
      >
        <DialogTitle>Super titre</DialogTitle>
        <DialogContent>
          {data !== undefined
          && (
          <Card className={classes.totalCard} variant="outlined">
            <GradeCard title="Knowledge" score={data.scoreKN} total={totals.KNTotal} />
            <GradeCard title="RC" score={data.scoreRC} total={totals.RCTotal} />
            <GradeCard
              title="Total"
              score={data.scoreKN + data.scoreRC}
              total={data.total}
            />
          </Card>
          )}
          <MaterialTable
            title="Detailed results"
            columns={columns}
            options={{
              search: true,
              exportButton: true,
              exportAllData: true,
              sorting: true,
              tableLayout: 'auto',
            }}
            data={examResults}
          />
        </DialogContent>
        <Button
          onClick={() => {
            setOpen(false);
            setExamId(null);
          }}
          autoFocus
        >
          Ok
        </Button>
      </Dialog>
    </>
  );
};

ExamResultsDetails.propTypes = {
  examId: PropTypes.string.isRequired,
};

export default ExamResultsDetails;
